<div class="swd-page">
  <div class="swd-page-header">
    <h1 class="swd-page-title">{{ 'unauthorized.title' | translate }}</h1>
  </div>

  <div class="swd-page-content">
    <div class="swd-empty-state">
      <p>{{ 'unauthorized.message' | translate }}</p>
      <a
        class="swd-link"
        routerLink="/">
        {{ 'unauthorized.returnHome' | translate }}
      </a>
    </div>
  </div>
</div>
